import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";

import { useBarContext } from "@/components/BannerSlider/components/controls/components/progressBar/components/bar/context/bar.context";
import { progressBar } from "@/components/BannerSlider/components/controls/components/progressBar/components/bar/progressBar.variants";
import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";

type Props = {
    className?: string;
};

export const Content = ({ className }: Props) => {
    const { delay } = useBannerSliderContext();

    const { isRunning, isStopped, isActive } = useBarContext();

    const { controls_progressBar_bar_content } = bannerSlider();

    return (
        <div
            className={progressBar({
                delay: `${delay}`,
                rounded: true,
                isRunning: isRunning,
                isStopped: isStopped,
                isActive: isActive,
                className: controls_progressBar_bar_content({ className })
            })}
        />
    );
};
